import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from 'Components/Layout';
import HomePage from '@/pages/HomePage'
import { QuotationPage } from '@/pages/QuotationPage'
import QuotationsComparatorPage from '@/pages/QuotationsComparatorPage'
import QuotationsComparatorDiff from '@/pages/QuotationsComparatorDiff/';
import { AdminPanelPage } from '@/pages/AdminPanelPage';
import { ExternalFormPage } from '@/pages/ExternalFormPage';
import { AgreementPage } from '@/pages/AgreementPage';
import PageNotFound from '@/pages/PageNotFound';
import { ROUTES } from './routes';

export const AppRouter = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path={ROUTES.HOME} element={<HomePage />} />
        <Route path={ROUTES.EXTERNAL} element={<Navigate to={ROUTES.QUOTATIONS.CREATE} replace />} />
        <Route path={ROUTES.QUOTATIONS.CREATE} element={<QuotationPage action='create' />} />
        <Route path={ROUTES.QUOTATIONS.UPDATE()} element={<QuotationPage action='update' />} />
        <Route path={ROUTES.QUOTATIONS.PLANS.LIST()} element={<QuotationsComparatorPage />} />
        <Route path={ROUTES.QUOTATIONS.PLANS.COMPARISON()} element={<QuotationsComparatorDiff />} />
        <Route path={ROUTES.ADMIN_PANEL} element={<AdminPanelPage />} />
        <Route path={ROUTES.AUTO_FORM} element={<ExternalFormPage />} />
        <Route path={ROUTES.AGREEMENTS.CREATE} element={<AgreementPage action='create' />} />
        <Route path={ROUTES.AGREEMENTS.VIEW()} element={<AgreementPage action='view' />} />
        <Route path={ROUTES.AGREEMENTS.UPDATE()} element={<AgreementPage action='update' />} />
        {/* <Route path='/external' element={<Navigate to='/dataform' />} /> */}
        {/* <Route path='/dataform' element={<DataGatewayPage />} /> */}
        {/* <Route path='/edit/:quotationId' element={<Edit />} /> */}
        <Route path={ROUTES.NOT_FOUND} element={<PageNotFound />} />
      </Route>
    </Routes>
  )
}